import { render, staticRenderFns } from "./AuditControl.vue?vue&type=template&id=521ff08e&scoped=true"
import script from "./AuditControl.vue?vue&type=script&lang=ts"
export * from "./AuditControl.vue?vue&type=script&lang=ts"
import style0 from "./AuditControl.vue?vue&type=style&index=0&id=521ff08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ff08e",
  null
  
)

export default component.exports